import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { StarRating } from 'src/components/molecules/StarRating/components/StarRating';
import { Partner } from 'src/types';
import { Review } from 'src/types/reviews';
import { getIconPath } from 'src/utils';
import { REVIEWED_ON } from '../constants/copy';
import { dateFormatHelper } from '../helpers/dateFormatHelper';
import { ExpandableTextContainer } from './ExpandableTextContainer';
import * as styles from '../styles/ProductReview.styles';

export interface ProductReviewProps {
  review: Review;
  partner: Partner;
  onExpandReviewClick: (isOpen: boolean) => void;
}

export const REVIEW_ITEM_ID_PREFIX = 'customer-review';

const ACCOUNT_CIRCLE = getIconPath('icons-16-account-circle.svg');

export const ProductReview = ({ partner, review, onExpandReviewClick }: ProductReviewProps) => (
  <>
    <div css={styles.ratingSection}>
      <StarRating productRating={review.rating} accessibleLabel={`${review.rating} out of 5`} />
      <span css={styles.dateText}>
        {REVIEWED_ON} {dateFormatHelper(review.date)}
      </span>
    </div>
    <ExpandableTextContainer
      textContainerId={`${REVIEW_ITEM_ID_PREFIX}-${review.id}`}
      onToggle={onExpandReviewClick}
    >
      <div id={`${REVIEW_ITEM_ID_PREFIX}${review.id}`} css={styles.commentText}>
        {review.comment}
      </div>
    </ExpandableTextContainer>
    {review.rating <= 2 && review.response && (
      <div id={`${REVIEW_ITEM_ID_PREFIX}${review.id}`} css={styles.partnerResponseWrapper}>
        <div css={styles.partnerNameWrapper}>
          <img css={styles.partnerIcon} src={ACCOUNT_CIRCLE} width={16} height={16} alt="" />
          <span css={visuallyHidden}>Response from </span>
          {partner.name}
        </div>
        <ExpandableTextContainer
          textContainerId={`${REVIEW_ITEM_ID_PREFIX}-partner-response-${review.id}`}
          darkBackground
        >
          <p css={styles.partnerResponseText}>{review.response}</p>
        </ExpandableTextContainer>
      </div>
    )}
  </>
);
